import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="bg-white px-3 py-3 sm:px-4 sm:py-4" data-id="element-69" data-mp="1o3x1pk7r0m0y">
      <div className="mx-auto flex max-w-3xl items-start gap-2.5 rounded-xl border border-eq-line bg-eq-light p-3 shadow-sm" data-id="element-70" data-mp="1o5q24hrrqa0i">
        <ShieldCheckIcon className="h-7 w-7 shrink-0 text-eq-gold" aria-hidden="true" data-id="element-71" data-mp="1x4l7jrmzng2r" />
        <div data-id="element-72" data-mp="1x2igd4a3ngwg">
          <h2 className="mb-0.5 font-display text-base font-extrabold uppercase leading-tight tracking-tight sm:text-3xl" data-id="element-73" data-mp="19ehfmhj5x4rl">
            Your Purchase Is 100% Protected
          </h2>
          <p className="text-[12px] font-medium leading-snug text-eq-muted sm:text-base" data-id="element-74" data-mp="14dtide4cbrox">
            Try Horse Riding Instructor Pro™ for 14 full days. Explore the lesson plans, exercises,
            progressions, arena setups, assessments, planning tools, and bonuses. If you decide it
            isn’t right for you, contact us within 14 days for a full refund.{' '}
            <span className="font-bold text-eq-navy" data-id="element-75" data-mp="lowkz1dncj2h">Zero risk.</span>
          </p>
        </div>
      </div>
    </section>;
}